/*
 * Copyright (c) 2021 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */
import React, {Component, Fragment} from "react";
import {observer} from "mobx-react";
import {RouterStore} from "mobx-router5";
import BaseRouteView from './components/BaseRouteView/BaseRouteView';
import {IRegistrationDetails} from "./stores/GatewayManager/IGatewayRegistrationInterfaces";

export interface IProps {
    routerStore: RouterStore;
}

export interface IAppState {
  captured: boolean;
}

@observer
export default class App extends Component<Object, IAppState> {
    constructor(props: Object) {
        super(props);
        this.state = {
          captured: false
        };
    }

    componentDidMount() {
        // parse the URl parameters
        let regDetails = this.getQueryParameters();
        if (regDetails.serialNumber) {
            sessionStorage.setItem("sn", regDetails.serialNumber)
        }
        if (regDetails.epName) {
            sessionStorage.setItem("epName", regDetails.epName)
        }
        if (regDetails.deviceId) {
            sessionStorage.setItem("devId", regDetails.deviceId || '')
        }
        if (regDetails.enrollmentId) {
            sessionStorage.setItem("enrId", regDetails.enrollmentId || '')
        }
        this.setState({
          captured: true
        });
    }

    render() {
        return (this.state.captured) ? (
            <Fragment>
                <BaseRouteView/>
            </Fragment>
        ): <></>;
    }

    /**
     * Return the query parameter values from window.location.query
     * @returns {IRegistrationDetails}
     */
    private getQueryParameters = (): IRegistrationDetails => {
        const queryString = require('query-string');
        const parsedQueryString = queryString.parse(window.location.search);
        let sn = parsedQueryString.deviceSerialNumber,
            epName = parsedQueryString.originalEp,
            devId = parsedQueryString.deviceId,
            enrId = parsedQueryString.enrollmentId;
        return {
            serialNumber: sn,
            epName: epName,
            deviceId: devId,
            enrollmentId: enrId
        };
    };
}
